// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## customerReportResultAnswer Get
/**
 *
 * @param {{params: object, query: { page: number, search: string, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.CustomerReportResultAnswer.GetAll(option)
  );
  console.log(response);
  const checker = await ResponseChecker(defaultMessages, response);
  console.log(checker);
  return checker;
};

// ## customerReportResultAnswer Create
/**
 *
 * @param {Array<{customerReportResultId: string, customerReportQuestionId: string, options: Array<{optionId: string, title: string, description: string}>, text: string[]}>} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.CustomerReportResultAnswer.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## customerReportResultAnswer Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.CustomerReportResultAnswer.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## customerReportResultAnswer Update
/**
 *
 * @param {{title: string, description: string}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.CustomerReportResultAnswer.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## customerReportResultAnswer Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.CustomerReportResultAnswer.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
